import * as React from "react";
const SvgFiRrVideoDuration = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-video-duration_svg__a)">
      <path
        fill="#062147"
        d="M18 12c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m1.707-3.707a.999.999 0 1 1-1.414 1.414l-1-1A1 1 0 0 1 17 18v-2a1 1 0 1 1 2 0v1.586zM24 5v5a1 1 0 1 1-2 0V5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v10c0 1.654 1.346 3 3 3h4a1 1 0 1 1 0 2H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-9.108 6.144-4.137 2.298A1.182 1.182 0 0 1 9 12.409V7.812c0-.901.968-1.47 1.755-1.033l4.137 2.299c.81.45.81 1.615 0 2.065z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-video-duration_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVideoDuration;
